<template lang="pug">
  .component-instruction-step
    .steps
      .row
        .columns.large-4.small-12
          label Step Type
            select(v-model="step.type", @change="$emit('resetValue')")
              option(value="html") html
              option(value="youtube") youtube
              option(value="image") Image
              option(value="linked_image") Linked image
        .columns.large-8.small-12
          .editor(v-if="step.type === 'html'")
            label Description
            Editor(v-model="step.value",  :value="step.value")
          label(v-else-if="step.type === 'youtube'",) Youtube embed url
            input(type="text", v-model="step.value")
          .uploader(v-else-if="step.type === 'image'")
            KeplerFileUpload(selected-prefix="vehicle-instructions", :previewUrl="step.value", selected-visibility="public", @sel="handleFileSelector($event, step.type)")
          .uploader(v-else-if="step.type === 'linked_image'")
            label URL
            input(type="text", v-model="step.image_link")
            KeplerFileUpload(selected-prefix="vehicle-instructions", :previewUrl="step.image_url", selected-visibility="public", @sel="handleFileSelector($event, step.type)")
          .text-right(style="margin-top:10px")
            button.button.small.warning(@click="$emit('remove')") Remove


</template>

<script>
  import Editor from './Editor'
  import KeplerFileUpload from '../KeplerFileUpload'

  export default {
    name: 'InstructionStep',
    components: {KeplerFileUpload, Editor},
    watch: {
      step: {
        handler(val) {
          if (val.type === 'linked_image') {
            val.value = `${val.image_url}|${val.image_link}`
          }

          if (val.type === 'youtube') {
            const regex = /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w\-]+\?v=|embed\/|shorts\/|v\/)?)([\w\-]+)(\S+)?$/
            const result = val.value.match(regex)
            try {
              val.value = `https://www.youtube.com/embed/${result[5]}`
            } catch (e) {
            }
          }
        },

        deep: true
      }
    },
    data() {
      return {
        type: 'html',
        value: '',
      }
    },
    methods: {
      handleFileSelector(path, type) {
        if (type === 'linked_image') {
          this.$set(this.step, 'image_url', path)
        } else {
          this.$set(this.step, 'value', path)
        }
      }
    },
    props: ['step'],
  }
</script>

<style lang="sass">
  .component-instruction-step
    background: rgba(202, 202, 202, 0.39)
    padding: 20px
    margin-top: 10px

</style>



// WEBPACK FOOTER //
// InstructionStep.vue?06ea4139